import React from 'react';
import { TableRow } from '@mui/material';

import { Stage23HierarchySchema } from '../../../types';
import CollapsableButtonCell from 'src/Esg/Dmav2/components/CollapseButtonCell';
import { useDmaImpacts, useRiskOpportunities } from 'src/Esg/Dmav2/hooks';
import { useEsgReports } from 'src/Esg/hooks';
import { useParams } from 'react-router-dom';
import MatterRow from './MatterRow';
import { prepareData } from './utils';

interface Props {
  title: string;
  data: Stage23HierarchySchema;
  visibleTopic?: string;
  setVisibleTopic: (topic?: string) => void;
}

export default function TitleRow(props: Props) {
  const { title, data, visibleTopic, setVisibleTopic } = props;
  const { reportId } = useParams();
  const { _instance: report } = useEsgReports({ id: Number(reportId) });
  const impacts = useDmaImpacts({ esg_dma_id: report?.esg_dma_id });
  const riskOpportunities = useRiskOpportunities({
    esg_dma_id: report?.esg_dma_id,
  });

  const [collapsed, setCollapsed] = React.useState<boolean>(false);

  // wait for impacts and riskOpportunities to load
  if (riskOpportunities.isLoading || impacts.isLoading) return null;

  const matters = prepareData(data, impacts._data, riskOpportunities._data);

  // do not show empty rows
  if (matters.length === 0) return null;

  const isVisible = visibleTopic === title;

  return (
    <>
      <TableRow>
        <CollapsableButtonCell
          style={{ padding: '8px' }}
          colSpan={13}
          text={title}
          collapsed={!isVisible}
          setCollapsed={() => setVisibleTopic(isVisible ? undefined : title)}
          sx={{ bgcolor: data.color || '' }}
        />
      </TableRow>

      {isVisible &&
        matters.map(({ subSubTopicId, title, impact, riskOpportunity }) => (
          <MatterRow
            key={`${subSubTopicId}-${impact?.id}-${riskOpportunity?.id}`}
            title={title}
            impact={impact}
            riskOpportunity={riskOpportunity}
          />
        ))}
    </>
  );
}
